export default function init(handler) {
  handler.mock.onGet(/\/v1\/products\/6a0fafcf-fba1-46ab-8fc3-e77a3611f79b/).reply(
    200,
    JSON.stringify({
      msg: 'OK',
      code: 200,
      data: {
        product: {
          active: true,
          all_barcode: "6261101531013;",
          app_name: "شامپو فرش ا لیتر",
          barcode: "6261101531013",
          brand: "سپید",
          brand_id: "00000000-0000-0000-0000-000000000000",
          consumer_price: 0,
          cover_id: "bda82219-9351-4e55-8e6d-45ab66448d0c",
          created_at: "2018-07-19T12:43:58.1050876+04:30",
          current_discount: 0,
          current_price: 71200,
          deleted_at: null,
          department_code: "",
          department_id: "00000000-0000-0000-0000-000000000000",
          department_name: "",
          description: "",
          discount_flag: true,
          discount_group_id: "00000000-0000-0000-0000-000000000000",
          discount_group_name: "",
          external_id: "10190069",
          gallery: null,
          height: 0,
          id: "2cbb38ab-3190-42b1-b015-e6645b768841",
          language_id: 314,
          last_price: 43050,
          name: "سپید شامپو فرش ا لیتر 12 عدد",
          name_in_pos: "سپید شامپو فرش ا لیتر سپید شامپو فرش ا لیتر سپید شامپو فرش ا لیتر سپید شامپو فرش ا لیتر سپید شامپو فرش ا لیتر",
          parent_id: "00000000-0000-0000-0000-000000000000",
          parent_nodes: null,
          product_type: "",
          quantity: 4,
          report_group_id: "00000000-0000-0000-0000-000000000000",
          report_group_name: "",
          reserved: 0,
          status: "",
          status_id: 243,
          stock_id: "287695d4-6fb8-49cb-b208-6b982749bc3e",
          store_id: 10,
          supplier_id: "00000000-0000-0000-0000-000000000000",
          supplier_name: "",
          tax_group_id: "00000000-0000-0000-0000-000000000000",
          tax_group_name: "",
          tax_percent: 6,
          taxable: true,
          type_id: 237,
          unit_od_measure: "",
          updated_at: "2018-12-12T19:29:57.5490413+03:30",
          weight: 0,
          width: 0,
          cover: {
            created_at: "2018-12-12T19:29:49.1957152+03:30",
            deleted_at: null,
            description: "",
            id: "bda82219-9351-4e55-8e6d-45ab66448d0c",
            title: "6261101531013",
            updated_at: "2018-12-12T19:29:49.1957152+03:30",
            url: "http://cs123.ir:27907/assets/images/bda82219-9351-4e55-8e6d-45ab66448d0c.png",
          }
        }
      }
    })
  )

}
